import { Component, OnInit, OnDestroy, Input, ChangeDetectionStrategy } from '@angular/core'
import * as fromShopStore from '@app/shop/store'
import { Subject } from 'rxjs'
import { Store } from '@ngrx/store'
import { distinctUntilChanged, map, switchMap, takeUntil, tap } from 'rxjs/operators'
import { ShopShopOrder } from '@app/shop/models/shopOrder.model'
import { RedirectService } from '@app/shared'

@Component({
    selector: 'app-shop-order-history',
    templateUrl: './shop-order-history.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ShopOrderHistoryComponent implements OnInit, OnDestroy {
  destroyed$ = new Subject<boolean>()
  currentShopOrder
  devView = false
  // Every route is prefixed by the session's userIndex (/#/2/shop/...). Linking back without it
  // drops the multi-tenant session and lands on whichever company index 0 happens to be.
  userIndex = '0'

  constructor(private store: Store<fromShopStore.State>, private redirectService: RedirectService) { }

  ngOnInit() {
    this.userIndex = this.redirectService.getUrlIndex()
    this.store.select(fromShopStore.selectShopOrder).pipe(
        takeUntil(this.destroyed$),
        map(order => {
            if(order){
              this.currentShopOrder = order
            }
        })
      ).subscribe()
   }

  ngOnDestroy() {
    this.destroyed$.next(true)
    this.destroyed$.complete()
  }
}
